export default __webpack_public_path__ + "4590dad9a6b2f051fc84a0ecb85c80fe.svg";